/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { sandboxDownloadArchive } from "../../funcs/sandboxDownloadArchive.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DownloadWorkspaceArchiveRequest$inboundSchema,
};

export const tool$sandboxDownloadArchive: ToolDefinition<typeof args> = {
  name: "sandbox-download-archive",
  description: `Download Workspace Archive

Download a zip archive containing the selected workspace paths.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await sandboxDownloadArchive(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
